import React from 'react';
import layerImage from './Query_white.svg'
import CloseIcon from '@material-ui/icons/Close';
import QueryMenu from './QueryMenu'
import { Trans } from 'react-i18next';
import DataGrid from './QueryDataGrid'
import { connect } from "react-redux";
import axios from 'axios'
import { useEffect } from "react";

function AddLayerComponent(props) {
    const [rows, setRows] = React.useState([]);
    useEffect(()=>{

        try {
            if (props.query.action === false){
                setRows([])
            }else{
        const GEOSERVER = props.query.layer.serviceUrl;
        var cql_query = ""
        
        switch (props.query.operator.type) {
            case "Geometric":
                cql_query = `${props.query.operator.name}(${props.query.field.fieldName}, ${props.query.value})`
                break;
            case "Compare":
                cql_query = `strToLowerCase(${props.query.field.fieldName}) ${props.query.operator.name} '${props.query.value}'`
                break;
            case "Function":
                let value = ""
                switch (props.query.operator.name) {
                    case "IN":
                        value = `(${props.query.value})`
                        cql_query = `strToLowerCase(${props.query.field.fieldName}) ${props.query.operator.name} ${value}`
                        break;
                    case "IS NULL":
                        cql_query = `strToLowerCase(${props.query.field.fieldName}) ${props.query.operator.name}`
                        break;
                    case "IS NOT NULL":
                        cql_query = `strToLowerCase(${props.query.field.fieldName}) ${props.query.operator.name}`
                        break;
                    case "BETWEEN":
                        
                        cql_query = `strToLowerCase(${props.query.field.fieldName}) ${props.query.operator.name} ${props.query.value}`
                        break;
                    case "NOT BETWEEN":
                        cql_query = `strToLowerCase(${props.query.field.fieldName}) ${props.query.operator.name} ${props.query.value}`
                        break;
                    default:
                        value = `'${props.query.value}'`
                        cql_query = `strToLowerCase(${props.query.field.fieldName}) ${props.query.operator.name} ${value}`
                        break;
                }
                
                break;
            default:
                break;
        }
        const newOpt = {
                "service":"WFS",
                "request":"GetFeature",
                "typeName": props.query.layer.name,
                "maxFeatures":1000,
                "outputFormat":"application/json",
                "format_options": 'callback:getJson',
                "cql_filter": cql_query
                }
                        
                        
        axios.get(GEOSERVER, { params: newOpt, headers: window.tp_headers})
        .then(({ data }) => {
            var a = []
                data.features.map((x,index)=>{
                    a.push(x.properties)
                    a[index]["id"] = index
                    return null
                })
            setRows(a)

        })
        .catch(error => {});
    }
        } catch (error) {
            
        }

    },[props.query])

const exportCSV =()=>{
    var data = rows
    if(data && data.length > 0){
        const infoKeys = props.query.layer.infoField.fields

        let csv = ""
        let arrayField = []
        infoKeys.map(x=>{
            if (x.visible ===true ){
            arrayField.push(x.fieldName)
            csv += x.fieldLabel + ","
            }
        })        
        csv = csv.replace(/,$/, "") + "\n"
        
        data.map(x=>{
            let value = ""            
            arrayField.map(y=>{ 
                if(x[y] == null) x[y] = ''
                value += x[y] + ","                
            })
            csv += value.replace(/,$/, "") +"\n"        
        })
                var hiddenElement = document.createElement('a');
                hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
                hiddenElement.target = '_blank';
                hiddenElement.download = props.query.layer.name + '.csv'; //layer.csv';
                hiddenElement.click();
    }
}

  return (
        <div className={"lateraltDiv"}>
            <div className={"title"}>
                <img src={layerImage} alt="Calcolo" className={"tocImage"}></img><Trans>QUERY</Trans> <button className={"buttonClose"} onClick={props.callback}><CloseIcon/></button>
            </div>
            <div className={"addQueryDiv"}>
                <QueryMenu/>
            </div>
            <DataGrid data={props.query} rows={rows}/>
            <button className={"csvQueryStyle"} onClick={exportCSV}>Export CSV</button>
        </div>

  );
}
const mapStateToProps = state => {
    return {
        query: state.query.query
    }
  }
  export default connect(mapStateToProps) (AddLayerComponent);